import { defineCopy } from '@/i18n'

// Shared by the header and footer
export default defineCopy('layout', {
  id: {
    links: {
      home: 'Home',
      overview: 'Ringkasan',
      features: 'Fitur',
      appPreview: 'Tampilan Aplikasi',
      rolesPrivacy: 'Peran & Privasi',
      pricing: 'Harga',
      faq: 'FAQ',
      about: 'Tentang Kami',
      services: 'Layanan',
      projects: 'Proyek',
      contact: 'Kontak',
      contactUs: 'Hubungi Kami',
      privacyPolicy: 'Kebijakan Privasi',
    },
    nav: {
      toggleMenu: 'Buka atau tutup navigasi',
      language: 'Bahasa',
    },
    // "by Miraverse.ID" under the Homekind and Mira Solutions logos
    brand: {
      byline: 'oleh Miraverse.ID',
    },
    footer: {
      descHomekind:
        'Satu aplikasi untuk semua urusan rumah, dibuat untuk keluarga Indonesia oleh Miraverse.ID.',
      descMiraverse:
        'Pembuat Homekind, aplikasi pengelola rumah tangga untuk keluarga Indonesia, sekaligus partner solusi IT untuk bisnis Anda.',
      descMiraSolutions:
        'Solusi IT untuk bisnis Anda: website perusahaan, aplikasi web & mobile, ERP, CRM, dan cloud.',
    },
  },
  en: {
    links: {
      home: 'Home',
      overview: 'Overview',
      features: 'Features',
      appPreview: 'App Preview',
      rolesPrivacy: 'Roles & Privacy',
      pricing: 'Pricing',
      faq: 'FAQ',
      about: 'About Us',
      services: 'Services',
      projects: 'Projects',
      contact: 'Contact',
      contactUs: 'Contact Us',
      privacyPolicy: 'Privacy Policy',
    },
    nav: {
      toggleMenu: 'Toggle navigation',
      language: 'Language',
    },
    // "by Miraverse.ID" under the Homekind and Mira Solutions logos
    brand: {
      byline: 'by Miraverse.ID',
    },
    footer: {
      descHomekind:
        'One app for everything at home, made for Indonesian families by Miraverse.ID.',
      descMiraverse:
        'The makers of Homekind, the household app for Indonesian families, and an IT solutions partner for your business.',
      descMiraSolutions:
        'IT solutions for your business: company websites, web & mobile apps, ERP, CRM, and cloud.',
    },
  },
})
